/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems,
      sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
    });
    
    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
    
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      if(document.querySelector('#PopupModal-quickshop')){
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
      }
      if(qtyInput) qtyInput.value = 1;
      if(this.cartElement){
        this.cartElement._updateCart(dataJSON.sections, 'open_drawer');
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }      
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }
    $qtyInput.value = finalQty;
    this.qty_errorMessage =  this.closest('.product-details-wrapper').querySelector('.quentity_message');
    
    this.limitedQTY=this.qty_errorMessage.dataset.qty;
    if (this.limitedQTY && finalQty >= this.limitedQTY) {
      this.qty_errorMessage.classList.remove('d-none');
    }else{
      this.qty_errorMessage.classList.add('d-none');
    }
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
  }

  connectedCallback() {
    // Element Connected callback
    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    this.updateOptionAvailability();
    
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }

    if (this.formType === 'product-page') {
      window.globalVariables.product.currentVariant = this.currentVariant;
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: this.currentVariant }));
    
      const variant = this.currentVariant;
      if (!variant) {return false}
      const allVariants = window.globalVariables.product.variants;
    
      // Get other selected option values except "Size"
      const selectedOptions = window.globalVariables.product.options.reduce((acc, optionName, index) => {
        const value = variant.options[index];
        if (optionName.toLowerCase() !== 'size') {
          acc[optionName] = value;
        }
        return acc;
      }, {});
    
      // Now loop through each size option element
      document.querySelectorAll('[data-optionname="Size"] .swatch, [data-optionname="size"] .swatch').forEach(optionEl => {
        const unitValue = parseFloat(optionEl.querySelector('[data-unit-price]')?.getAttribute('data-unit-price'));
        const weightUnit = optionEl.querySelector('[data-unit-price]')?.getAttribute('data-weight-unit');
        const sizeValue = optionEl.querySelector('input').value;
    
        if (!isNaN(unitValue) && sizeValue) {
          // Try to find the matching variant
          const matchingVariant = allVariants.find(v => {
            let matches = true;
    
            // Match all other selected options
            for (const [name, value] of Object.entries(selectedOptions)) {
              const idx = window.globalVariables.product.options.findIndex(optName => optName.toLowerCase() === name.toLowerCase());
              if (v.options[idx] !== value) {
                matches = false;
                break;
              }
            }
    
            // Match the size value too
            const sizeIndex = window.globalVariables.product.options.findIndex(opt => opt.toLowerCase() === 'size');
            if (sizeIndex >= 0 && v.options[sizeIndex] !== sizeValue) {
              matches = false;
            }

            return matches;
          });
    
          if (matchingVariant) {
            if (matchingVariant.sku.includes('D-')) {
              optionEl.querySelector('[data-unit-price]').classList.add('d-none');
            } else {
              const variantPrice = parseFloat(matchingVariant.price) / 100;
              const calculatedUnitPrice = variantPrice / unitValue;
      
              optionEl.querySelector('[data-unit-price]').innerHTML = `(${Utility.formatMoney((calculatedUnitPrice * 100), window.globalVariables.money_format)}/${weightUnit})`;
              optionEl.querySelector('[data-unit-price]').classList.remove('d-none');
              optionEl.querySelector('[data-unit-price]').classList.add('d-block');
            }
          }
        }
      });
    }
  }

  /**
   * Update option availability and add/remove disabled class
   */
  updateOptionAvailability() {
    const variantsArray = this._getVariantData();
    const selectedOptions = (this.variantPicker == 'variant-select') ? 
      this._getOptionsFromSelect() : 
      this._getOptionsFromRadio();

    // Handle both select dropdowns and radio buttons
    if (this.variantPicker == 'variant-select') {
      this.querySelectorAll('.variant_selector').forEach((select, index) => {
        const options = Array.from(select.options);
        options.forEach(option => {
          const isAvailable = this._isOptionAvailable(option.value, index, selectedOptions, variantsArray);
          const swatch = option.closest('.swatch');
          if (!isAvailable) {
            option.classList.add('disabled');
            if(swatch?.querySelector('[data-unit-price]')) swatch.querySelector('[data-unit-price]').classList.add('d-none');
          } else {
            option.classList.remove('disabled');
            if(swatch?.querySelector('[data-unit-price]')) swatch.querySelector('[data-unit-price]').querySelector('[data-unit-price]').classList.remove('d-none');
          }
        });
      });
    } else {
      // For radio buttons
      const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
      fieldsets.forEach((fieldset, index) => {
        const radios = fieldset.querySelectorAll('input[type="radio"]:not(.addon-swatch)');
        radios.forEach(radio => {
          const isAvailable = this._isOptionAvailable(radio.value, index, selectedOptions, variantsArray);
          const swatch = radio.closest('.swatch');
          if (!isAvailable) {
            swatch?.classList.add('disabled');
            // radio.disabled = true;
            if(swatch?.querySelector('[data-unit-price]')) swatch.querySelector('[data-unit-price]').classList.add('d-none');
          } else {
            // if(!first_checked_radio && disabled_was_checked_radio) {
            //  first_checked_radio =  true;
            //  radio.checked = true;
            //  this.dispatchEvent(new Event('change', { bubbles: true }));
            // }
            swatch?.classList.remove('disabled');
            // radio.disabled = false;
            if(swatch?.querySelector('[data-unit-price]')) swatch.querySelector('[data-unit-price]').classList.remove('d-none');
          }


        });

      });
    }

    // Auto-select next available option if current selection is disabled
    let fieldsetSize = this.querySelector('fieldset[data-optionname=size]');
    let hasDisabledRadioChecked = fieldsetSize.querySelector('.swatch.disabled input[type="radio"]:checked');
    if(hasDisabledRadioChecked) {
      let firstEnabledRadio = fieldsetSize.querySelector('.swatch:not(.disabled) input[type="radio"]');
      if(firstEnabledRadio) {
        firstEnabledRadio.checked = true;
        firstEnabledRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  /**
   * Check if a specific option value is available
   * @param {string} optionValue 
   * @param {number} index 
   * @param {array} selectedOptions 
   * @param {array} variants 
   * @returns {boolean}
   */
  _isOptionAvailable(optionValue, index, selectedOptions, variants) {
    const currentOptions = [...selectedOptions];
    currentOptions[index] = optionValue;

    return variants.some(variant => {
      return variant.options.every((option, i) => {
        return currentOptions[i] === option || currentOptions[i] === undefined;
      }) && variant.available;
    });
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;

        document.dispatchEvent(new Event('variant:changed'));
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.textContent = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    
    let priceElement = container.querySelectorAll('[data-currentPrice]');
    let subscription_price = container.querySelectorAll('[data-subscription_price]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) {
      priceElement.forEach( ele => {
        ele.textContent = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);  
      })
    if (subscription_price) {
      subscription_price.forEach( ele => {
        
        ele.textContent = Utility.formatMoney(currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);  
      })
    }  
    }
    
    if(comparePriceElement) {
      comparePriceElement.textContent = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      if(currentVariant.compare_at_price == null || currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price == currentVariant.price){
        comparePriceElement.classList.add('d-none');
      }else{
        comparePriceElement.classList.remove('d-none');
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn?.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);

class rechargeWidget extends HTMLElement {
  constructor() {
    super();

    this.optionSelectors = this.querySelectorAll('[data-purchase_type]');
    this.sellingPlans=this.querySelectorAll('[data-purchase_type="subscription"] select');

  }
  connectedCallback() {
    this.optionSelectors?.forEach(option => option.addEventListener('click', this._toggleOptions.bind(this)));
    this._changeSellingPlan('load');
    this.sellingPlans?.forEach(plan => plan.addEventListener('change', this._changeSellingPlan.bind(this)));
  }
  
  _toggleOptions(event){
  

    let form=event.target.closest('form');
    if (form.closest('[data-product-container]') && form.querySelector('recharge-widget')) {
      this.variantsData=JSON.parse(form.querySelector('[data-variantJSON]').innerText);
      let type=form.querySelector('[name="selling_plan"]:checked')?.closest('[data-purchase_type]')?.getAttribute('data-purchase_type');
      document.querySelector('[data-purchase_type].selected')?.classList.remove('selected');
      document.querySelector(`[data-purchase_type="${type}"]`)?.classList.add('selected');

      let variant = globalVariables.product.currentVariant;
      let compareAtPrice = variant.compare_at_price || variant.price;
      let regularPriceInput = this.closest('form')?.querySelector('[data-ragular-price-prop]');
      
      if (!regularPriceInput) return;

      if (type == "onetime") {
        regularPriceInput.value = '';
        regularPriceInput.disabled = true;  
      } else {
        regularPriceInput.value = Utility.formatMoney((compareAtPrice), window.globalVariables.money_format) || '';
        regularPriceInput.disabled = false;
      }

    }
  }

  _changeSellingPlan(event){
    if (event =='load') {
      let id = this.querySelector('[data-purchase_type="subscription"] select').value;
      this.querySelector('[data-purchase_type="subscription"]').querySelector('[name="selling_plan"]').value = id;
    } else {
      let id = event.target.value;
      event.target.closest('[data-purchase_type]').querySelector('[name="selling_plan"]').value=id;
    }
    
  }
}
customElements.define('recharge-widget', rechargeWidget);


document.addEventListener('variant:changed', (e) => {
  let datawrapperEle = document.querySelector('[data-variant-accordions]');
  if (datawrapperEle) datawrapperEle.innerHTML = '';
  let accordionData = document.querySelector('[data-pdp-variants-accordions]');

  if (!accordionData && !e.detail) {return false}
  accordionData = JSON.parse(accordionData.textContent);

  if(!e.detail) {return false}
  let data = e.detail.options.find(opt => accordionData[opt.toLowerCase().replace(/\./g, '_').replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '').replace(/-+/g, '-').replace(/^[-_]+|[-_]+$/g, '')]);
  (!data) ? datawrapperEle.closest('.collapsible_panel').classList.add('d-none'): datawrapperEle.closest('.collapsible_panel').classList.remove('d-none');
  if (data) {
    data = accordionData[data.toLowerCase().replace(/\./g, '_').replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '').replace(/-+/g, '-').replace(/^[-_]+|[-_]+$/g, '')];
    let html = `
        ${Object.values(data).map(acc => {
          return `
            <div class="collapsible_panel border-0 tab_container" data-accoddion-for="${acc.title}" is="collapsiblePanel">
              <h6 class="panel_toggle d-flex align-items-center fs-lg text-uppercase mb-0 fs-15" aria-expanded="false">
                ${acc.title}
                <span class="icon-plus ms-auto icon-size-10"></span>
              </h6>                        
              <div class="toggle-content" data-type="content" style="">
                <div class="toggle-content-wrap">${acc.value}</div>
              </div>
            </div>
          `;
        }).join('')}
      `;
  
    if(datawrapperEle) datawrapperEle.innerHTML = html;
  }
  collapsiblePanel?.init(datawrapperEle);
})